import React from 'react';
import Grid from '@material-ui/core/Grid';
import Place from '@material-ui/icons/Place';
import Image from '@material-ui/icons/Image';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Location from '@material-ui/icons/LocationOn';
import LinkIcon from '@material-ui/icons/Link';
import { Link } from 'react-router-dom';
import Update from '@material-ui/icons/Update';
import New from '@material-ui/icons/FiberNew';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import Button from '@material-ui/core/Button';
import Star from '@material-ui/icons/Star';
import Message from '@material-ui/icons/Message';
import ArrowForward from '@material-ui/icons/ArrowForward';
import moment from 'moment/moment';
import { API_ROOT } from 'Api/Routes';
import Tooltip from 'Tooltip';

import styled from 'styled-components';

const LinkToPhase = styled(Link)`
  text-decoration: none;
  color: initial;
`;
const Regions = styled.span`
  word-break: break-word;
`;
const CompanyName = styled.p`
  align-self: center;
`;

const StatusNotification = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  color: red;
  svg {
    height: unset !important;
    width: 2rem !important;
    float: right;
  }
`;
const ShortListed = styled.div`
  padding: 1px 14px 0px 14px;
  color: white;
  background: #ffca28;
  transform: rotate(45deg);
  position: absolute;
  top: 14px;
  right: -26px;
`;
const InfoIcons = styled.div``;
const SlipContent = styled.div`
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  padding-left: 2px !important;
  padding-right: 2px !important;
  display: flex;
  flex-direction: column;
`;
const SpecInfoAndRegionsWrapper = styled.p`
  margin-top: 5px;
  margin-bottom: 5px;
`;

const InfoIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`;

const RepliedInfo = styled.span`
  flex: 1;
  margin-right: 10px;
`;

const SlipImage = styled.div`
  margin-top: 2px;
  margin-left: 2px;
  margin-bottom: 2px;
  margin-right: 2px;
`;
const TicketImage = styled.div`
  // display: block;
  // width: 100%;
  margin-right: 0 !important;
`;

const ImageWraper = styled.div`
  padding: 0 !important;
  margin-bottom: 0 !important;
  justify-content: center;
`;

const SlipImagePrew = styled.div`
  background-image: ${({ IdForUrl }) =>
    IdForUrl && 'url(' + API_ROOT + '/asset/' + IdForUrl + ')'};
`;

const ImageInfoIcon = id => (
  <span data-tip="Has image" data-for={'imgID' + id}>
    <Tooltip tooltipId={'imgID' + id} />
    <Image />
  </span>
);

const LinkInfoIcon = id => (
  <span data-tip="Has link" data-for={'linkID' + id}>
    <Tooltip tooltipId={'linkID' + id} />
    <LinkIcon />
  </span>
);

const MessageInfoIcon = id => (
  <span data-tip="Has conversation" data-for={'msgID' + id}>
    <Tooltip tooltipId={'msgID' + id} />
    <Message />
  </span>
);

class SlipCard extends React.Component {
  state = {
    newProjectDialogOpen: false,
    anchorEl: null,
    showHover: false,
  };
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleOpenEditDialog = () => {
    this.setState({ newProjectDialogOpen: true });
    this.handleClose();
  };
  handleCloseEditDialog = () => {
    this.setState({ newProjectDialogOpen: false });
  };
  regionsToString = regions => {
    regions = regions.join(', ');
    return regions.replace(new RegExp('_', 'g'), ' ');
  };
  renderSpecificationSheetInfo = specInfo => {
    if (!specInfo) return;
    delete specInfo.manufacturer;
    return this.regionsToString(Object.values(specInfo));
  };

  render() {
    const { anchorEl } = this.state;
    return (
      <Grid item xs={12} className="border-radius">
        <Paper
          // onMouseEnter={() => {
          //   this.setState({ showHover: true });
          // }}
          // onMouseLeave={() => {
          //   this.setState({ showHover: false });
          // }}
          className="slip-box new-slip updated-slip project-card ov-hiden"
        >
          {this.state.showHover && (
            <div className="project-card-hover">
              {/* <div className="project-card-hover-top">
                <div className="project-card-hover-menu">
                  <IconButton
                    aria-label="More"
                    aria-owns={anchorEl ? 'long-menu' : null}
                    aria-haspopup="true"
                    onClick={this.handleClick}
                    className="pull-right"
                  >
                    <MoreHoriz className="project-card-hover-more-icon" />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleClose}
                  >
                    <MenuItem key={0} onClick={this.handleOpenEditDialog}>
                      Edit
                    </MenuItem>
                    <MenuItem key={1} onClick={this.handleClose}>
                      Archive
                    </MenuItem>
                    <MenuItem key={2} onClick={this.handleClose}>
                      Delete
                    </MenuItem>
                  </Menu>
                </div>
              </div> */}
              <div>
                <Button
                  variant="text"
                  className="hollow-button"
                  component={Link}
                  to={{
                    pathname: `/demand/project/${this.props.projectId}/ticket/${this.props.ticketId}/slip/${this.props.slip.id}`,
                    state: {
                      slipsIds: this.props.slipsIds,
                    },
                  }}
                >
                  View
                </Button>
                <div className="slip-hover-icons">
                  <Star />
                  <Message />
                  <ArrowForward />
                </div>
              </div>
            </div>
          )}

          <LinkToPhase
            to={{
              pathname: `/demand/project/${this.props.projectId}/ticket/${this.props.ticketId}/slip/${this.props.slip.id}`,
              state: {
                slipsIds: this.props.slipsIds,
              },
            }}
          >
            <div className="slip-card">
              <ImageWraper
                className="favorite-tickets project-card sidebar-tickets"
                data-tip="Show luminaire"
                data-for={'ID1' + this.props.slip.id}
              >
                <Tooltip tooltipId={'ID1' + this.props.slip.id} />
                <SlipImage
                  className="ticket-card-basic sidebar-tickets-main"
                  // className="slip-image"
                  // style={{
                  //   backgroundImage:
                  //     this.props.slip && this.props.slip.image1Id
                  //       ? `url(${API_ROOT}/asset/${this.props.slip.image1Id}`
                  //       : 'none',
                  // }}
                >
                  <TicketImage className="ticket-image">
                    {this.props.slip && this.props.slip.image1Id ? (
                      <SlipImagePrew IdForUrl={this.props.slip.image1Id} />
                    ) : (
                      <div />
                    )}
                    {this.props.slip && this.props.slip.image2Id ? (
                      <SlipImagePrew IdForUrl={this.props.slip.image2Id} />
                    ) : (
                      <div />
                    )}
                    {this.props.slip && this.props.slip.image3Id ? (
                      <SlipImagePrew IdForUrl={this.props.slip.image3Id} />
                    ) : (
                      <div />
                    )}
                    <div />
                  </TicketImage>
                </SlipImage>
              </ImageWraper>
              <SlipContent className="slip-content">
                <Tooltip tooltipId={'ID2' + this.props.slip.id} />
                <div
                  className="slip-main"
                  data-tip="Show luminaire"
                  data-for={'ID2' + this.props.slip.id}
                >
                  <div
                    className="slip-logo"
                    style={{
                      backgroundImage:
                        this.props.slip &&
                        this.props.slip.companyDetailsResponse.logoId
                          ? `url(${API_ROOT}/asset/${this.props.slip.companyDetailsResponse.logoId}`
                          : 'none',
                    }}
                  />
                  <CompanyName className="t-primary-16">
                    {this.props.slip
                      ? this.props.slip.companyDetailsResponse.companyName
                      : ''}
                  </CompanyName>
                  <StatusNotification>
                    {this.props.slipState === 'NEW' &&
                      !this.props.slip.shortlisted && <New />}

                    {this.props.slip.shortlisted &&
                      this.props.slipState !== 'DEAL' && (
                        <ShortListed>shortlisted</ShortListed>
                      )}
                    {this.props.slip.updated && <Update />}
                  </StatusNotification>
                </div>

                <SpecInfoAndRegionsWrapper
                  className="t-secondary-12 c-secondary slip-location "
                  data-tip="Show luminaire"
                  data-for={'ID3' + this.props.slip.id}
                >
                  {this.props.slipState === 'RESPONDED' ||
                  this.props.slipState === 'DEAL'
                    ? this.renderSpecificationSheetInfo(
                        this.props.specSheetCriteria
                      )
                    : null
                  // this is if we decide to go back to regions in desc
                  // (
                  //   <React.Fragment>
                  //     <Location />
                  //     <Regions>
                  //       {this.props.slip
                  //         ? this.regionsToString(
                  //             this.props.slip.companyDetailsResponse.regions
                  //           )
                  //         : ''}
                  //     </Regions>
                  //   </React.Fragment>
                  // )
                  }
                </SpecInfoAndRegionsWrapper>
                <Tooltip tooltipId={'ID3' + this.props.slip.id} />

                <InfoIconWrapper className="slip-replied-date c-secondary t-secondary-12">
                  <RepliedInfo
                    data-tip="Show luminaire"
                    data-for={'ID4' + this.props.slip.id}
                  >
                    <Tooltip tooltipId={'ID4' + this.props.slip.id} />
                    <b>Replied:</b>{' '}
                    {moment(this.props.slip.creatorInfo.dateCreated).format(
                      'MMM Do YYYY'
                    )}{' '}
                  </RepliedInfo>
                  <InfoIcons className="slip-shortcut">
                    {this.props.slip &&
                      (this.props.slip.hasImage1Id ||
                        this.props.slip.hasImage2Id) && <ImageInfoIcon />}
                    {this.props.slip && this.props.slip.hasNote && (
                      <MessageInfoIcon />
                    )}
                    {this.props.slip && this.props.slip.hasUrl && (
                      <LinkInfoIcon id={this.props.slip.id} />
                    )}
                  </InfoIcons>
                </InfoIconWrapper>
              </SlipContent>
            </div>
          </LinkToPhase>
        </Paper>
      </Grid>
    );
  }
}

export default SlipCard;
